export const FreeUseDay = 7;